import { cleanTailoredTask } from "../server/lib/clean-tailored-task.mjs"
import { createCompareAuditTask } from "../server/lib/create-compare-audit-task.mjs"

export function formatCreateTailoredAudit({
    originalTask,
    tailoredTask,
    tailoringReferenceId,
    schedule,
    scheduleItem,
    reason,
    skills,
}) {
    const originalTaskValues = createCompareAuditTask(originalTask, skills)
    const tailoredTaskValues = createCompareAuditTask(tailoredTask, skills)
    const cleanTailoredTaskValues = cleanTailoredTask(tailoredTaskValues, originalTaskValues)
    const taskTailoringReferenceId = `${tailoringReferenceId}.${originalTask.id}`

    const audit = {
        referenceId: taskTailoringReferenceId,
        reason: reason,
        scheduleId: schedule.id,
        scheduleVersion: scheduleItem.version,
        scheduleTitle: schedule.title,
        scheduleCode: scheduleItem.code,
        taskId: originalTask.id,
        taskTitle: originalTask.title,
        originalValues: originalTaskValues,
        tailoredValues: cleanTailoredTaskValues,
    }

    return audit
}
